<template>
    <div>
        <v-progress-linear indeterminate linear></v-progress-linear>
        <div class="text-h6 text-center py-6">Saindo...</div>
    </div>
</template>
<script>
import { clearAuth } from '@/services/authService'

export default {
    mounted() {
        this.logout()
    },
    methods: {
        async logout() {
            try {
                await this.$axios.post('auth/logout')
            } catch { /* ignora erros de rede */ }
            clearAuth()
            const qs = this.$route.query.q ? `?code=${this.$route.query.q}` : ''
            this.$router.replace(`/${qs}`)
        },
    },
}
</script>
